export default "__VITE_ASSET__BPimGzX___"